import React from 'react'


const AboutEn = () => {
  return (
      
      <main className='abaut-container'>
        <section>
    <h1 id="main-content-title" tabIndex="-1">FAQ​​​​<br/></h1>
   TLV OpenData Portal is dedicated to promoting access to government data and encouraging the development of creative tools to engage and serve Tel-Aviv&#39;s diverse community. 
   <br/>
   <h2>What data does the TLV OpenData Portal hold?</h2>
    You can view all open datasets in our current 
   <a href="#/dset/0">catalogue</a>. In time, it will be expanded to include a large majority of our data. Not all data can be released due to privacy reasons. 
   <h2>
      <span class="ms-rteThemeForeColor-2-0">Will you publish my private data?</span><br/></h2> Rigorous processes are in place to protect your privacy. We will not publish any data of a private or sensitive nature. 
   <h2>
      <span class="ms-rteThemeForeColor-2-0">What can I do with the data?</span></h2> Under our data policies, you are free to share and adapt our data for any purpose, provided you give the appropriate credit. 
   <h2>How often is the data updated?</h2> The frequency of updates differs for each dataset and is outlined within each dataset’s metadata. Select the ‘Info’ tab when viewing a dataset to find the update frequency, last updated date and version control. 
   <h2>
      <span class="ms-rteThemeForeColor-2-0">How do I report an error within a dataset?</span></h2> If you detect an error or believe a dataset is incomplete, you can select the ‘Discuss’ tab and post a comment.
      </section>   
      </main>
  )
}

export default AboutEn